import { useEffect, useRef } from 'react'
import { buildBackendUrl } from '../lib/backend-url'

const POLL_INTERVAL_MS = 20_000

export function useReminderNotifications(userId) {
  const seenRef = useRef(new Set())

  useEffect(() => {
    if (!userId) return

    const authToken = localStorage.getItem('zoy_auth_token')
    if (!authToken) return

    let isMounted = true

    const markRead = async (notificationId) => {
      try {
        await fetch(buildBackendUrl(`/api/notifications/${notificationId}/read`), {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        })
      } catch (error) {
        console.error('Failed to mark notification as read', error)
      }
    }

    const showReminder = async (notificationId) => {
      if (seenRef.current.has(notificationId)) return
      seenRef.current.add(notificationId)

      if (!('Notification' in window)) {
        await markRead(notificationId)
        return
      }

      if (Notification.permission === 'default') {
        await Notification.requestPermission()
      }

      if (Notification.permission === 'granted') {
        new Notification('Task Reminder', { body: 'A task reminder is due now.' })
      }

      await markRead(notificationId)
    }

    const pollNotifications = async () => {
      try {
        const response = await fetch(buildBackendUrl('/api/notifications'), {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        })
        if (!response.ok) return

        const data = await response.json()
        const reminders = (data.notifications || []).filter(
          (n) => n.notification_type === 'reminder' && !n.is_read,
        )

        for (const reminder of reminders) {
          if (!isMounted) return
          await showReminder(reminder.id)
        }
      } catch (error) {
        console.error('Failed to poll notifications', error)
      }
    }

    pollNotifications()
    const intervalId = window.setInterval(pollNotifications, POLL_INTERVAL_MS)

    return () => {
      isMounted = false
      window.clearInterval(intervalId)
    }
  }, [userId])
}
